// extracted by mini-css-extract-plugin
export var bullets = "GalleryStyles-module--bullets--5fbc7";
export var cases = "GalleryStyles-module--cases--33020";
export var container = "GalleryStyles-module--container--347d2";
export var cta = "GalleryStyles-module--cta--1567f";
export var ctaWithTags = "GalleryStyles-module--ctaWithTags--28502";
export var fadeInAnimation = "GalleryStyles-module--fadeInAnimation--eee27";
export var gallery = "GalleryStyles-module--gallery--b43b0";
export var hidden = "GalleryStyles-module--hidden--6a0bf";
export var marginBottom = "GalleryStyles-module--marginBottom--2e04c";
export var marginTop = "GalleryStyles-module--marginTop--2943a";
export var marginTopNone = "GalleryStyles-module--marginTopNone--edc10";
export var slider = "GalleryStyles-module--slider--917f6";
export var whatWeDo = "GalleryStyles-module--whatWeDo--be6a8";
export var wrapper = "GalleryStyles-module--wrapper--f6b65";